const copyToClipboard = value => {
  try {
    const element = document.createElement('textarea');
    element.value = value;
    document.body.appendChild(element);
    element.select();
    document.execCommand('copy');
    document.body.removeChild(element);
  } catch (error) {
    console.log(error);
  }
};

export default copyToClipboard;
